// @ts-nocheck
import React from 'react';

function EmptyCell({ promotion, game, editable }) {
  return <div className={'grid-empty'}>---</div>;
}



export default EmptyCell;
